/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-FocusTrapZoneBoxExample{border:dashed 1px #ababab}"}]);
/* tslint:enable */